import React, { useEffect, useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { TextField, MenuItem, Card } from "@mui/material";
import dayjs from "dayjs";
import { productBranchHandler } from "../../../../../redux/handlers";
import { createTableColumns } from "../../../../../utils/createTableColumns";
import { useGlobalTable } from "../../../../../hooks/useGlobalTable";
import AllderTable from "../../../../../components/AllderTable";

const TYPE_ACTION_OPTIONS = [
  { value: "ALL", label: "ทั้งหมด" },
  { value: "CREATE", label: "สร้าง" },
  { value: "UPDATE", label: "แก้ไข" },
  { value: "DELETE", label: "ลบ" },
];

const TYPE_MAP = {
  CREATE: "สร้าง",
  UPDATE: "แก้ไข",
  DELETE: "ลบ",
};

const TEXTFIELD_STYLES = {
  InputProps: { sx: { borderRadius: "7px" } },
  sx: {
    ".Mui-disabled": {
      background: "#F8F8F9",
    },
  },
  className: "w-[200px] !ml",
  size: "small",
};

export default function ProductHistory() {
  const { productID } = useParams();
  const dispatch = useDispatch();
  const [actionType, setActionType] = useState("ALL");

  const fetchHistoryData = useCallback(
    async (params) => {
      const queryParams = {
        branch_product_id: productID,
        type: actionType !== "ALL" ? actionType : undefined,
        ...params,
      };
      return dispatch(productBranchHandler.getBranchProductLogs(queryParams));
    },
    [dispatch, productID, actionType]
  );

  const {
    data: historyData,
    loading,
    totalRows,
    paginationModel,
    setPaginationModel,
    handleSort,
  } = useGlobalTable({
    fetchData: fetchHistoryData,
    defaultSort: "created_at",
    defaultOrder: "desc",
    defaultPageSize: 20,
  });

  const handleExport = () => {
    const params = {
      branch_product_id: productID,
      type: actionType !== "ALL" ? actionType : undefined,
      start_date: undefined,
      end_date: undefined,
    };
    dispatch(productBranchHandler.exportBranchProductLogsToExcel(params));
  };

  const columns = createTableColumns([
    {
      field: "logDate",
      headerName: "วันที่",
      width: 180,
      sortable: true,
      renderCell: ({ row }) => (
        <div className="text-[#2DC76D]">
          {dayjs(row.logDate).format("DD/MM/YYYY HH:mm")} น.
        </div>
      ),
    },
    {
      field: "type",
      headerName: "LOG",
      width: 120,
      sortable: false,
    },
    {
      field: "detail",
      headerName: "รายละเอียด",
      flex: 1,
      minWidth: 300,
      sortable: false,
      renderCell: ({ row }) => (
        <div dangerouslySetInnerHTML={{ __html: row.detail }} />
      ),
    },
    {
      field: "user",
      headerName: "สมาชิก",
      width: 250,
      sortable: false,
      renderCell: ({ row }) => {
        if (!row.user) return "-";
        return (
          <div className="d-flex align-items-center">
            <span>
              {row.user.first_name} {row.user.last_name}
            </span>
          </div>
        );
      },
    },
  ]);

  return (
    <Card className="!rounded-lg mb-4">
      <div className="py-4">
        <div className="d-flex align-items-center px-4 mb-3 flex-wrap">
          <div className="me-3 mb-2" style={{ flex: "0 0 200px" }}>
            <TextField
              {...TEXTFIELD_STYLES}
              select
              label="เลือกดูตามประเภท"
              value={actionType}
              onChange={(e) => setActionType(e.target.value)}
              className="me-auto w-[200px]"
            >
              {TYPE_ACTION_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </div>
          <button
            className="btn btn-export-st-1 mb-2 me-auto"
            onClick={handleExport}
          >
            Export
          </button>
        </div>

        <AllderTable
          data={historyData}
          loading={loading}
          columns={columns}
          totalRows={totalRows}
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
          handleSort={handleSort}
        />
      </div>
    </Card>
  );
}
